import { GamepadLatencyStats } from './GamepadApi'

export interface LatencyTrackerOptions {
  windowSize: number
  enabled: boolean
}

const EMPTY_STATS: GamepadLatencyStats = { p50: 0, p95: 0, max: 0, sampleCount: 0 }

/**
 * Rolling-window latency stats (p50/p95/max) computed from
 * `deliveredTimestamp - sourceTimestamp` per snapshot. A no-op when disabled so
 * production builds carry zero overhead behind the input debug flag.
 */
export class LatencyTracker {
  private readonly samples: number[] = []

  constructor(private readonly opts: LatencyTrackerOptions) {}

  add(sourceTimestamp: number, deliveredTimestamp: number): void {
    if (!this.opts.enabled) return
    this.samples.push(deliveredTimestamp - sourceTimestamp)
    if (this.samples.length > this.opts.windowSize) this.samples.shift()
  }

  getStats(): GamepadLatencyStats {
    if (this.samples.length === 0) return { ...EMPTY_STATS }
    const sorted = [...this.samples].sort((a, b) => a - b)
    const pct = (p: number): number =>
      sorted[Math.min(sorted.length - 1, Math.ceil((p / 100) * sorted.length) - 1)]
    return {
      p50: pct(50),
      p95: pct(95),
      max: sorted[sorted.length - 1],
      sampleCount: sorted.length,
    }
  }
}
